// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface AtomFileLink
 */
export interface AtomFileLink {
  /**
   *
   */
  href: string;
  /**
   *
   */
  size: number;
  /**
   *
   */
  title?: string | null;
  /**
   * A spatial bounding box of 4 floats (x1, y1, x2, y2). For WGS84 we use traditional (x=lon, y=lat) order.
   */
  envelope?: Array<number> | null;
  /**
   *
   */
  time?: Date | null;
}

/**
 * Check if a given object implements the AtomFileLink interface.
 */
export function instanceOfAtomFileLink(value: object): value is AtomFileLink {
  if (!("href" in value) || value["href"] === undefined) return false;
  if (!("size" in value) || value["size"] === undefined) return false;
  return true;
}

export function AtomFileLinkFromJSON(json: any): AtomFileLink {
  return AtomFileLinkFromJSONTyped(json, false);
}

export function AtomFileLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): AtomFileLink {
  if (json == null) {
    return json;
  }
  return {
    href: json["href"],
    size: json["size"],
    title: json["title"] === undefined ? undefined : json["title"] === null ? null : json["title"],
    envelope:
      json["envelope"] === undefined
        ? undefined
        : json["envelope"] === null
        ? null
        : json["envelope"],
    time:
      json["time"] === undefined
        ? undefined
        : json["time"] === null
        ? null
        : parseDateTime(json["time"]),
  };
}

export function AtomFileLinkToJSON(json: any): AtomFileLink {
  return AtomFileLinkToJSONTyped(json, false);
}

export function AtomFileLinkToJSONTyped(
  value?: AtomFileLink | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    href: value["href"],
    size: value["size"],
    title: value["title"],
    envelope: value["envelope"],
    time: value["time"] == null ? value["time"] : serializeDateTime(value["time"]),
  };
}
